/**
 * frontend/src/pages/valuation/_NormalizeBalanceSheet.tsx
 *
 * VAL-U2C-SCREEN-1 — total assets and total liabilities, typed by the signer.
 * After Save the line "Stored: ..." is what the server returned on read-back.
 */
import { useState } from 'react'
import type { BalanceSheet } from '@/api/valuationNormalization'
import { money } from './_NormalizeYearTable'

const FIELD = 'mt-1 block w-full rounded border border-gray-300 px-2 py-1 text-sm'

interface Props {
  stored: BalanceSheet | null
  asOfYear?: number
  busy: boolean
  onSave: (body: { total_assets: number; total_liabilities: number; as_of_year: number | null }) => Promise<void>
}

export function NormalizeBalanceSheet({ stored, asOfYear, busy, onSave }: Props) {
  const [assets, setAssets] = useState(stored ? String(stored.total_assets) : '')
  const [liabilities, setLiabilities] = useState(stored ? String(stored.total_liabilities) : '')
  const ready =
    assets.trim() !== '' && liabilities.trim() !== '' && Number.isFinite(Number(assets)) && Number.isFinite(Number(liabilities))
  return (
    <section className="space-y-2">
      <h2 className="text-sm font-semibold text-gray-900">Balance sheet</h2>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-xs text-gray-600">Total assets
          <input type="number" className={FIELD} value={assets} onChange={e => setAssets(e.target.value)} />
        </label>
        <label className="text-xs text-gray-600">Total liabilities
          <input type="number" className={FIELD} value={liabilities} onChange={e => setLiabilities(e.target.value)} />
        </label>
      </div>
      <button
        type="button"
        disabled={!ready || busy}
        onClick={() => void onSave({
          total_assets: Number(assets),
          total_liabilities: Number(liabilities),
          as_of_year: stored?.as_of_year ?? asOfYear ?? null,
        })}
        className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-50 disabled:opacity-50"
      >
        Save balance sheet
      </button>
      {stored && (
        <p className="text-xs text-gray-500">
          Stored: assets {money(stored.total_assets)}, liabilities {money(stored.total_liabilities)}
        </p>
      )}
    </section>
  )
}
